import React from 'react';
import PropTypes from 'prop-types';
import { Provider, observer, inject } from 'mobx-react';
import GuestCandidateCollection from '~/glm/models/shared/guest-import/guest-candidate-collection';
import GuestCandidateModel from '~/glm/models/shared/guest-import/guest-candidate-model';
import Row from '~/glm/components/shared/guest-import/guest-import-spreadsheet/row';
import classNames from 'classnames';
import ExampleInput from '~/glm/components/shared/guest-import/guest-import-spreadsheet/example-input';
import cellStyles from './guest-import-spreadsheet/cell.scss';
import styles from './guest-import-spreadsheet.scss';

const { TABLE_COLUMN_MAPPING: columnHeaders } = GuestCandidateModel;

const GuestImportSpreadsheet = ({
  guestCandidates,
  disabled = false,
  themeStyles,
  handlePaste,
  handleTrackValidationError,
}) => (
  <Provider disabled={disabled}>
    <div className={styles.wrapper}>
      <div className={styles.rowWrapper}>
        {columnHeaders.map(field => (
          <div key={field.apiName} className={classNames(styles.headerCell, themeStyles, cellStyles[field.apiName])}>
            {field.humanName}
          </div>
        ))}
      </div>
      <div className={styles.examples}>
        <ExampleInput themeStyles={themeStyles} />
      </div>
      <div className={styles.rows}>
        {guestCandidates.guests.map((guest, index) => (
          <div className={styles.rowWrapper} key={index}>
            <Row
              handlePaste={handlePaste}
              handleTrackValidationError={handleTrackValidationError}
              rowId={index}
              guest={guest}
            />
          </div>
        ))}
      </div>
    </div>
  </Provider>
);

GuestImportSpreadsheet.defaultProps = {
  themeStyles: '',
};

GuestImportSpreadsheet.propTypes = {
  guestCandidates: PropTypes.instanceOf(GuestCandidateCollection).isRequired,
  themeStyles: PropTypes.string,
  disabled: PropTypes.bool,
  handlePaste: PropTypes.func,
  handleTrackValidationError: PropTypes.func,
};

export default inject('guestCandidates')(observer(GuestImportSpreadsheet));
